import { render, staticRenderFns } from "./capsuleTab.vue?vue&type=template&id=25a083cb&scoped=true"
import script from "./capsuleTab.vue?vue&type=script&lang=js"
export * from "./capsuleTab.vue?vue&type=script&lang=js"
import style0 from "./capsuleTab.vue?vue&type=style&index=0&id=25a083cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a083cb",
  null
  
)

export default component.exports